import { UIMatch } from 'react-router-dom'

export interface UIMatchWithSearch extends UIMatch {
  search: string
  isCustom: boolean
  params: Record<string, string>
}

export class HistoryStack extends Array<UIMatchWithSearch> {
  constructor(items: UIMatchWithSearch[]) {
    super(...items)
  }

  /**
   * get the last visited url
   * not considering the current one
   */
  public peek(): UIMatchWithSearch | undefined {
    if (this.length > 1) {
      return this[this.length - 2]
    }
  }

  /**
   * get the last visited url
   */
  public current(): UIMatchWithSearch | undefined {
    if (this.length > 0) {
      return this[this.length - 1]
    }
  }

  /**
   * get the last visited view
   */
  public getLastVisitedView(): UIMatchWithSearch | undefined {
    return [...this].reverse().find((item) => !item?.params['id'])
  }
}
